/**
 * Approval Speed Analytics Tracker
 * 
 * Isolated analytics utility for tracking approval timing.
 * This module is completely separate from business logic.
 */

class ApprovalSpeedTracker {
    constructor() {
        this.currentFocus = null // { answerId, questionId, submissionId, timestamp }
    }

    /**
     * Start tracking focus for a specific answer
     */
    startTracking(answerId, questionId, submissionId) {
        if (!answerId || !questionId || !submissionId) return

        this.currentFocus = {
            answerId,
            questionId,
            submissionId,
            timestamp: performance.now()
        }
        
        console.log('🔥 Analytics: Started tracking approval speed for answer', answerId)
    }

    /**
     * Calculate approval speed and clear tracking
     */
    calculateAndClear(answerId) {
        if (!this.currentFocus || 
            this.currentFocus.answerId !== answerId ||
            !Number.isFinite(this.currentFocus.timestamp)) {
            return null
        }

        const endTime = performance.now()
        const approvalSpeedMs = Math.round(endTime - this.currentFocus.timestamp)
        
        // Clear tracking data
        this.currentFocus = null
        
        // Validate reasonable timing (between 100ms and 5 minutes)
        if (approvalSpeedMs < 100 || approvalSpeedMs > (5 * 60 * 1000)) {
            console.log('⚠️ Analytics: Unreasonable approval speed', approvalSpeedMs, 'ms for answer', answerId)
            return null
        }
        
        console.log('✅ Analytics: Calculated approval speed', approvalSpeedMs, 'ms for answer', answerId)
        
        return approvalSpeedMs
    }

    /**
     * Check if we need to reset tracking for this answer
     */
    shouldReset(answerId, questionId, submissionId) {
        return !this.currentFocus || 
               this.currentFocus.answerId !== answerId ||
               this.currentFocus.questionId !== questionId ||
               this.currentFocus.submissionId !== submissionId
    }

    /**
     * Clear all tracking data (for cleanup)
     */
    clearAll() {
        this.currentFocus = null
    }
}

const approvalSpeedTracker = new ApprovalSpeedTracker()

export default approvalSpeedTracker 